import { render, staticRenderFns } from "./story.vue?vue&type=template&id=1056dd02&scoped=true&"
import script from "./story.vue?vue&type=script&lang=js&"
export * from "./story.vue?vue&type=script&lang=js&"
import style0 from "./story.vue?vue&type=style&index=0&id=1056dd02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1056dd02",
  null
  
)

export default component.exports